import { render, staticRenderFns } from "./dataset.vue?vue&type=template&id=f3d58e5a"
import script from "./dataset.vue?vue&type=script&lang=js"
export * from "./dataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports